import React, { useEffect, useState } from 'react'
import Slide from '@material-ui/core/Slide'
import PropTypes from 'prop-types'

const ScreenSlide = (props) => {

  const [opened, setOpened] = useState(true)

  useEffect(() => {
    return () => setOpened(false)
  }, [] );

  return <Slide direction='left' in={opened} mountOnEnter unmountOnExit>
    {props.children}
  </Slide>
}


ScreenSlide.propTypes = {
  children: PropTypes.any,
  direction: PropTypes.oneOf(['up', 'down', 'right', 'left'])
}

ScreenSlide.defaultProps = {
  direction: 'left'
}


export default ScreenSlide

